import Project from './project';


export abstract class BaseFilter {
  protected category: string;
  protected value: string;

  public constructor(option: any) {
    this.value = option['value'];
  }

  abstract filter(project: Project) : boolean;

}
